exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.image-upload[data-v-3d8c6730] {\n  padding-top: 12px;\n  padding-bottom: 12px;\n}\n.gif-search .search-text-box[data-v-3d8c6730] {\n  margin-bottom: 5px!important;\n  z-index: 10000000;\n  width: 275px;\n}\n.input-label[data-v-3d8c6730] {\n  font-size: 13px;\n  font-weight: bold;\n  color: #757575;\n}\n@media (max-width: 768px) {\n.gif-search .search-text-box[data-v-3d8c6730] {\n    width: 100%;\n}\n}\n\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3d8c6730","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1&bustCache!./src/components/standard/input/InputImage.vue
// module id = Obtk
// module chunks = 53